import React, { Component } from "react";
import Service from "../../common/Service";
import Progress from "../../common/Progress";
import add from "../../assets/add.svg";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { api } from "../../common/server";
import ServiceSelect from "../../common/ServiceSelect";
import ServiceInput from "../../common/ServiceInput";
import { reCreateNewDragula } from "../../utils/dragula";

const mapStateToProps = (state) => ({
  rizevo_login_data: state.rizevo_login_data,
  token: state.token,
  postOptions: state.postOptions,
});

const durations = [];
for (let hours = 0; hours <= 24; hours++) {
  for (let halfHour = 0; halfHour < 2; halfHour++) {
    const totalMinutes = hours * 60 + halfHour * 30;
    const text = `${hours > 0 ? hours + " hour" + (hours > 1 ? "s" : "") : ""}${halfHour > 0 ? (hours > 0 ? " " : "") + "30 min" : ""
      }`.trim();
    if (text) {
      durations.push({ text, value: totalMinutes });
    }
  }
}

export default connect(mapStateToProps)(
  class ServiceSettings extends Component {
    state = {
      add_new_service: true,
      services: [],
      editingServiceIndex: null,
      formDefaults: {},
      redirect: null,
      formValues: { name: "", duration: "", price: "" },
    };

    handleInputChange = (e) => {
      const { name, value } = e.target;
      this.setState((prevState) => ({
        formValues: {
          ...prevState.formValues,
          [name]: value,
        },
      }));
    };

    servicesDragRef = React.createRef();

    service_form = () => {
      this.setState({
        add_new_service: !this.state.add_new_service,
        editingServiceIndex: null,
        formDefaults: {},
        formValues: { name: "", duration: "", price: "" },
      });
    };

    all_services = (ev) => {
      ev.preventDefault();
      const { name, duration, price } = this.state.formValues;
      let newService;
      if (this.state.editingServiceIndex !== null) {
        const existing = this.state.services[this.state.editingServiceIndex];
        newService = {
          ...existing, // Keep id and order
          name,
          duration,
          price,
          is_active: true,
        };
      } else {
        // New service
        newService = {
          id: Date.now(),
          order: this.state.services.length + 1,
          name,
          duration,
          price,
          is_active: true,
        };
      }

      let servicesCopy;
      if (this.state.editingServiceIndex !== null) {
        // Only replace the edited service, keep others as is (no unnecessary cloning)
        servicesCopy = this.state.services.map((service, idx) =>
          idx === this.state.editingServiceIndex ? newService : service
        );
      } else {
        servicesCopy = [...this.state.services, newService];
      }

      servicesCopy = servicesCopy.map((s, idx) => ({ ...s, order: idx + 1 }));

      this.setState({
        services: servicesCopy,
        add_new_service: false,
        editingServiceIndex: null,
        formDefaults: {},
        formValues: { name: "", duration: "", price: "" },
      });
    };
    nextBtn = React.createRef();
    next = (ev) => {
      ev.preventDefault();

      const cleanServices = this.state.services.map(({ id, ...rest }) => rest);

      const data = { services: cleanServices };
      const button = this.nextBtn.current;
      button.classList.add("loading");

      fetch(`${api}/business/services`, {
        ...this.props.postOptions(),
        body: JSON.stringify(data),
      })
        .then(async (res) => {
          button.classList.remove("loading");

          // Parse the response body first
          const responseData = await res.json().catch(() => ({}));

          // Check for HTTP errors
          if (!res.ok) {
            // Create an error object with message
            const errorMessage =
              responseData.errors?.[0]?.message ||
              responseData.message ||
              `Request failed with status ${res.status}`;
            throw new Error(errorMessage);
          }

          // If successful (2xx)
          if (res.status.toString()[0] === "2") {
            this.setState({
              redirect: `/onboarding/booking/settings/${this.props.match.params.business_invite_code}`,
            });
          }

          return responseData;
        })
        .catch((error) => {
          button.classList.remove("loading");
          window.$.notify(
            error.message || "Something went wrong, please try again!",
            "error-alert"
          );
        });
    };

    editService = (service, index) => {
      this.setState({
        add_new_service: true,
        editingServiceIndex: index,
        formDefaults: {
          name: service.name,
          duration: service.duration,
          price: service.price,
        },
        formValues: {
          name: service.name,
          duration: service.duration,
          price: service.price,
        },
      });
    };

    deleteService = (service, index) => {
      const services = [...this.state.services];
      services.splice(index, 1);
      const updatedServices = services.map((s, idx) => ({
        ...s,
        order: idx + 1,
      }));

      this.setState({ services: updatedServices });

      if (updatedServices.length === 0) {
        this.setState({
          add_new_service: true,
          editingServiceIndex: null,
          formDefaults: {},
          formValues: { name: "", duration: "", price: "" },
        });
      }
    };


    addAnotherService = () => {
      const { name, duration, price } = this.state.formValues;
      if (!name || !duration || !price) return; // optional validation

      const newService = {
        id: Date.now(),
        order: this.state.services.length + 1,
        name,
        duration,
        price,
        is_active: true,
      };

      const updatedServices = [...this.state.services, newService].map((s, idx) => ({
        ...s,
        order: idx + 1,
      }));

      this.setState({
        services: updatedServices,
        formValues: { name: "", duration: "", price: "" }, // reset form for next entry
        add_new_service: true, // keep the form open
      });
    };


    componentDidMount() {
      // Initialize Dragula after services render
      setTimeout(() => {
        this.initDragula();
      }, 300);
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevState.services !== this.state.services) {
        this.initDragula();
      }
    }

    initDragula = () => {
      reCreateNewDragula({
        services: this.state.services,
        setServices: (updated) => this.setState({ services: updated }),
        servicesRef: this.servicesDragRef,
      });
    };

    render() {
      const sortedServices = [...this.state.services].sort(
        (a, b) => a.order - b.order
      );
      console.log(sortedServices, "sorted services");
      return (
        <div className="onboarding-page">
          {this.state.redirect ? <Redirect to={this.state.redirect} /> : ""}

          <Progress total={5} current={4}>
            <div className="form-title dsk">
              Add your services
              <p>
                Set up your services. You easily can create more or add details
                later.
              </p>
            </div>
          </Progress>

          <div className="form_step form-page">
            <h1 className="form-title mbl flex center">Add your services</h1>

            {/* all services */}
            <div
              className="card-container"
              style={{ display: this.state.add_new_service ? "none" : "block" }}
            >
              <div
                className="form-container card services services-list"
                ref={this.servicesDragRef}
              >
                {/* {this.state.services.map((service, idx) => ( */}
                {sortedServices.map((service, idx) => (
                  <Service
                    key={service.id}
                    data={service}
                    notEditable={false}
                    editOnclick={() => this.editService(service, idx)}
                    deleteOnclick={() => this.deleteService(service, idx)}
                    onToggleActive={(updatedService) => {
                      // Update the service in the parent state
                      this.setState((prev) => ({
                        services: prev.services.map((s, i) =>
                          i === idx ? { ...s, ...updatedService } : s
                        ),
                      }));
                    }}
                  />
                ))}
              </div>

              <button className="co-pink add" onClick={this.service_form}>
                <img src={add} alt="" />
                Add another service
              </button>

              <button
                className="default"
                ref={this.nextBtn}
                onClick={this.next}
              >
                Continue
              </button>
            </div>
            {/* end of all services */}

            {/* new service form  */}
            <div
              className="form-container card"
              style={{ display: this.state.add_new_service ? "block" : "none" }}
            >
              <form
                action=""
                onSubmit={this.all_services}
                key={
                  this.state.editingServiceIndex !== null
                    ? this.state.editingServiceIndex
                    : "new"
                }
              >
                <ServiceInput
                  label="Service Name"
                  name="name"
                  value={this.state.formValues.name}
                  onChange={this.handleInputChange}
                  required
                  placeholder="Enter service name"
                />
                <div></div>
                <div>
                  <div className="input-grid ">
                    <ServiceSelect
                      label="Duration"
                      name="duration"
                      value={this.state.formValues.duration}
                      onChange={this.handleInputChange}
                      required
                      placeholder="Duration"
                    >
                      {durations.map((duration) => (
                        <option value={duration.value} key={duration.value}>
                          {duration.text}
                        </option>
                      ))}
                    </ServiceSelect>

                    <span className="sep">-</span>

                    <ServiceInput
                      label="Price (₦)"
                      name="price"
                      type="number"
                      value={this.state.formValues.price}
                      onChange={this.handleInputChange}
                      required
                      placeholder="Enter Price"
                    />
                  </div>

                  <div>

                    {this.state.editingServiceIndex === null && (
                      <button className="co-pink add" type="button" onClick={this.addAnotherService}>
                        <img src={add} alt="Add" />
                        Add another service
                      </button>
                    )}

                    <div className="footer flex center space-btw">
                      {this.state.services.length > 0 && (
                        <button
                          className="left-btn"
                          type="button"
                          onClick={this.service_form}
                        >
                          Back to services
                        </button>
                      )}
                      {this.state.editingServiceIndex !== null ? (
                        <button className="default">Update Service</button>
                      ) : (
                        <button className="default">Next</button>
                      )}

                    </div>
                  </div>
                </div>
              </form>
            </div>
            {/*new service form */}
          </div>
        </div>
      );
    }
  }
);

export { durations };
